import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { UserDto } from "./UserDto";

export class GetUsersInDirectoryGroupResultDto extends DtoBase {

	public Users: List<UserDto>;

	constructor() {
		super();

		this.Users = new List<UserDto>();
	}

	public get HasUsers(): boolean {
		return (!!this.Users && this.Users.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_users_in_directory_group_result = {};
		obj = obj.get_users_in_directory_group_result;

		super.Write(obj, context);

		if (this.HasUsers) {
			obj.users = [];
			ObjSerUtils.WriteObjSerCollection(obj.users, this.Users, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_users_in_directory_group_result)
			throw new Error();
		obj = obj.get_users_in_directory_group_result;

		super.Read(obj, context);

		if (obj.users !== undefined) {
			this.Users = new List<UserDto>();
			ObjSerUtils.ReadObjSerCollection(obj.users, this.Users,
				(value: any) => new UserDto(), context);
		}
	}

}
